var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.33333H14",
    stroke: "#364863",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4V13.6C13 13.9713 12.8495 14.3274 12.5816 14.5899C12.3137 14.8525 11.9503 15 11.5714 15H4.42857C4.04969 15 3.68633 14.8525 3.41842 14.5899C3.15051 14.3274 3 13.9713 3 13.6V4M5 4V2.4C5 2.0287 5.15051 1.6726 5.41842 1.41005C5.68633 1.1475 6.04969 1 6.42857 1L9.57143 1C9.95031 1 10.3137 1.1475 10.5816 1.41005C10.8495 1.6726 11 2.0287 11 2.4V4",
    stroke: "#364863",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8V11",
    stroke: "#364863",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8V11",
    stroke: "#364863",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconNew);
export default __webpack_public_path__ + "static/media/delete-icon-new.4ceb69ef31888a1349c12a4fab5cf6aa.svg";
export { ForwardRef as ReactComponent };